import { CommunityPost } from "../../../services/post.api";
import { UIPost } from "../components/post/interfaces/post.interface";

/**
 * Convert an API CommunityPost to the UI-side UIPost.
 */
export function communityPostToUIPost(post: CommunityPost): UIPost {
  return {
    id: post.id,
    author: {
      id: post.author.id,
      name: post.author.name,
      avatarUrl: post.author.avatarUrl,
    },
    content: post.body,
    mediaFiles: post.media ?? [],
    isOwner: post.isOwner,
    createdAt: post.createdAt,
    updatedAt: post.updatedAt,
    visibility: post.visibility,
  };
}

/**
 * Format a date string as relative time (e.g., "2h", "3d").
 */
export function formatRelativeTime(iso: string): string {
  const date = new Date(iso);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);

  if (diffSec < 60) return "just now";
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h`;
  if (diffSec < 604800) return `${Math.floor(diffSec / 86400)}d`;

  return date.toLocaleDateString();
}